import $ from 'jquery';
import { Howl } from 'howler';

import plugin from './plugin';

class PluginPlayer {
	constructor(element, options) {
		const $element = $(element);
		this.$player = $element;

		this.options = Object.assign({}, options, {
			classPlayButton: 'fa fa-play',
			classPlayButtonActive: 'fa fa-pause',
		});

		// Cache references to DOM elements.
		['group', 'track', 'playBtn', 'playIcon', 'progress', 'time', 'title', 'drySwitch', 'waveform'].forEach(elm => {
			this['$' + elm] = $element.find(`.${elm}`);
		});

		// play/pause
		this.$playBtn.on('click', () => this.togglePause());

		// seek
		this.$waveform.on('click', e => {
			const $this = $(e.currentTarget);
			this.seekPercent((e.clientX - $this.offset().left) / $this.width());
		});

		// change track
		this.$track.on('click', e => {
			this.switchTrack($(e.currentTarget));
		});

		// change group
		this.$group.on('click', e => {
			this.currentSeek = null;
			const $this = $(e.currentTarget);
			const groupId = $this.data('id');
			$element.find('.group').removeClass('active');
			$this.addClass('active');
			$element.find('.tracks').hide();
			const $tracks = $element.find(`.tracks-${groupId}`);
			$tracks.show();
			// this.switchTrack($tracks.find('.track').first());
		});

		this.$drySwitch.on('click', e => {
			e.stopImmediatePropagation();
			this.toggleDry()
		});

		this.tracks = [];
		this.dryOn = false;

		this.load($('.track.active'));
	}

	switchTrack($el) {
		this.$player.find('.track').removeClass('active');
		$el.addClass('active');
		this.load($el, true);
	}

	/**
	 * Play a song in the playlist.
	 * @param	{jQuery} $element JQuery element to play :)
	 */
	load($element, start) {
		const src = $element.data('src'), srcDry = $element.data('src-dry');
		this.$title.text($element.data('title'));
		const waveform = this.$waveform[0];
		waveform.dataset.wave = $element.data('samples');
		waveform.dispatchEvent(new Event('build'));
		waveform.addEventListener('seek', e => this.seekPercent(e.detail / 100));

		if (this.track) {
			this.track.unload();
		}
		if (this.trackDry) {
			this.trackDry.unload();
		}


		const howlConfig = {
			src,
			html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
			volume: 0,

			onplay: () => {
				// Start upating the progress of the track.
				this.$playIcon.removeClass(this.options.classPlayButton).addClass(this.options.classPlayButtonActive); // active means paused
				requestAnimationFrame(this.step.bind(this));
			},
			onpause: () => {
				this.$playIcon.removeClass(this.options.classPlayButtonActive).addClass(this.options.classPlayButton);
				if (this.trackDry) {
					this.trackDry.pause();
				}
			},
			onseek: () => {
				// Start upating the progress of the track.
				if (this.trackDry) {
					this.trackDry.seek(this.track.seek());
				}
				if (this.track.playing()) {
					requestAnimationFrame(this.step.bind(this));
				}
			},
			onend: () => {
				this.$playIcon.removeClass(this.options.classPlayButtonActive).addClass(this.options.classPlayButton);
			},
			onload: () => {
				// Begin playing the sound.
			}
		};
		this.track = new Howl(howlConfig);

		if (srcDry) {
			this.trackDry = new Howl({
				src: srcDry,
				html5: true,
				volume: 0
			});
		} else {
			this.trackDry = null;
		}
		if (start) {
			this.play1(true);
		}

	}


	/**
	 * Pause the currently playing track.
	 */
	togglePause() {
		if (this.track.playing()) {
			// this.track.fade(1, 0, 200);
			// window.setTimeout(() => this.track.pause(), 200)
			this.track.pause();
		} else {
			this.play1();
		}
	}


	play1(forceRestart) {
		if (!this.soundId || forceRestart) {
			this.soundId = this.track.play();
			this.track.fade(0, 1, 200);
			if (this.trackDry) {
				this.soundIdDry = this.trackDry.play();
			}
		} else {
			this.track.play(this.soundId);
			if (this.trackDry) {
				this.trackDry.play(this.soundIdDry);
			}
		}
		this.toggleDry(false);
	}


	toggleDry(toggleOn) {
		if (!this.trackDry) return; // ? not sure here

		if (typeof toggleOn === 'undefined') toggleOn = !this.dryOn;
		let on, off;
		if (toggleOn) {
			this.track.fade(1, 0, 200);
			this.trackDry.fade(0, 1, 200);
			this.dryOn = true;
			off = '.wet'; on = '.dry';
		} else {
			this.trackDry.fade(1, 0, 200);
			this.track.fade(0, 1, 200);
			this.dryOn = false;
			on = '.wet'; off = '.dry';
		}
		this.$drySwitch.children(off).removeClass('active');
		this.$drySwitch.children(on).addClass('active');
	}


	/**
	 * Seek to a new position in the currently playing track.
	 * @param	{Number} percent Percentage through the song to skip.
	 */
	seekPercent(percent) {
		// Convert the percent into a seek position.
		this.track.seek(this.track.duration() * percent);
		this.updateProgress(percent);
	}

	step() {
		const seek = this.track.seek() || 0;
		const duration = this.track.duration();

		this.$time.text(`${this.formatTime(seek)}/${this.formatTime(duration)}`);
		this.updateProgress(seek / duration);

		if (this.track.playing()) {
			requestAnimationFrame(this.step.bind(this))
		}
	}

	updateProgress(percent) {
		this.$progress.css({transform: `translateX(-${100 - (percent * 100)}%)`});
		this.$waveform[0].dispatchEvent(new CustomEvent('play', {detail: percent}));
	}

	/**
	 * Format the time from seconds to M:SS.
	 * @param	{Number} secs Seconds to format.
	 * @return {String}			Formatted time.
	 */
	formatTime(secs) {
		secs = Math.round(secs);
		var minutes = Math.floor(secs / 60) || 0;
		var seconds = (secs - minutes * 60) || 0;

		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	}
}

plugin('PluginPlayer', PluginPlayer);

